import produce from "immer";
import first from "lodash/first";
import pull from "lodash/pull";
import pullAllBy from "lodash/pullAllBy";
import { CustomizationState } from "../";
import { findPrintQuantity } from "../../../utils/customization/finders";
import { addPageMutation, generateNewPage } from "../../../utils/customization/page";

export interface ChangePrintQuantityAction {
  type: "changePrintQuantity";
  pageKey: string;
  quantity: number;
}

export function changePrintQuantity(
  state: CustomizationState,
  action: ChangePrintQuantityAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { pageKey, quantity } = action;

    if (draftState.content.templateType !== "print") {
      throw new Error("changePrintQuantity is for templateType being print");
    }
    const printQuantity = findPrintQuantity(pageKey, draftState.content);

    printQuantity.quantity += quantity;

    if (printQuantity.quantity <= 0) {
      pull(draftState.content.printQuantities, printQuantity);
      pullAllBy(draftState.content.pages, [{ key: pageKey }], "key");
    }

    if (draftState.content.pages.length === 0) {
      const firstTemplatePageDefinition = first(draftState.template.pageDefinitions);
      if (!firstTemplatePageDefinition) {
        return;
      }
      const newPage = generateNewPage(firstTemplatePageDefinition.key, draftState.template);
      addPageMutation(newPage, draftState.content);
    }
  });
}
